import React, { Component, Fragment } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import Draggable from 'react-draggable';

import { FetchData } from './utils/DataFetch';
import { GetCookie, Timeout, IsImpersonation } from './utils/Common';

import Logo from '../images/logo1.png';

import { WorkOrderIntFormEndTimeComment } from './WorkOrderIntFormEndTimeComment';

import SaveIcon from '../images/save-icon.png';
import RemoveIcon from '../images/remove-icon.png';

const moment = require('moment');

export class WorkOrderIntFormEndTime extends Component {
  static displayName = WorkOrderIntFormEndTime.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      alert: props.alert,

      modalEndTimeComment: false,
      model: props.model,

      newModel: {
        UnAvailable: false,
        JobDate: null,
        FollowUpTimeString: '',
      },
      savedFinishTime: '',
      isSubmitting: false,

      localEvent: {
        isBackspaceClick: false,
        isYesClick: false,
      },
      elementModel: {
        ampm: 'AM',
        display_message: '',
        disableButtons: 'disabled',
      },
      deltaPosition: { x: 0, y: 0 },
    };

    //
    this.setModalEndTimeComment = this.setModalEndTimeComment.bind(this);
    //
    this.handleYesClick = this.handleYesClick.bind(this);
    this.handleNoClick = this.handleNoClick.bind(this);
    this.handleSubmitClick = this.handleSubmitClick.bind(this);
    //
    this.handleChange = this.handleChange.bind(this);
    this.handleFollowUpTimeChange = this.handleFollowUpTimeChange.bind(this);
    this.handleNewModelChange = this.handleNewModelChange.bind(this);
    this.handlekeyDown = this.handlekeyDown.bind(this);
    // Validators
    this.validateFinishTime = this.validateFinishTime.bind(this);
    this.validateFollowUpTime = this.validateFollowUpTime.bind(this);
    //
    this.handleSaveEventSuccessComment =
      this.handleSaveEventSuccessComment.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag(e, ui) {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  }

  componentDidMount() {
    let model = { ...this.state.model };
    let elementModel = { ...this.state.elementModel };

    // Reset the finish time string
    model.FinishTimeString = '';

    // Set AM/PM to match the job start time
    if (this.props.model.JobDateTime) {
      // Extract AM/PM from the job time
      const timeString = this.props.model.JobDateTime.toUpperCase();

      // Check if it explicitly contains AM or PM
      if (timeString.includes('AM')) {
        elementModel.ampm = 'AM';
      } else if (timeString.includes('PM')) {
        elementModel.ampm = 'PM';
      } else {
        // If for some reason AM/PM isn't in the string, infer from 24-hour format
        // This is a fallback in case the format is different
        const hourPart = parseInt(timeString.split(':')[0], 10);
        elementModel.ampm = hourPart >= 12 ? 'PM' : 'AM';
      }
    }

    this.setState({
      model: model,
      elementModel: elementModel,
    });
  }

  handlekeyDown(e) {
    let evtModel = { ...this.state.localEvent };
    // backspace
    evtModel.isBackspaceClick = e.keyCode === 8 ? true : false;
    this.setState({ localEvent: evtModel });
  }

  handleNewModelChange(e) {
    if (!e || !e.target) return;
    let model = { ...this.state.newModel };

    if (e.target.type === 'checkbox') {
      const field = e.target.name;
      model[field] = !model[field];
    } else {
      model[e.target.name] = e.target.value;
    }
    // Fix: update the correct state key (newModel)
    this.setState({ newModel: model });
  }

  setModalEndTimeComment() {
    this.setState({ modalEndTimeComment: !this.state.modalEndTimeComment });
  }

  handleChange(e) {
    if (!e || !e.target) return;
    let model = { ...this.state.model };
    var finishTime = null;

    // For HTML time inputs, accept the value as-is and let the browser manage formatting
    if (e.target.type === 'time') {
      model.FinishTimeString = e.target.value;
      this.setState({ model }, () => this.validateFinishTime());
      return;
    }

    if (e.target.type === 'checkbox') {
      const field = e.target.name;
      if (field) {
        // Toggle boolean: if undefined treat as false then invert
        model[field] = !model[field];
        this.setState({ model });
      }
      return; // Do not process further for checkbox
    }
    // Legacy support for text inputs (if any remain)
    if (this.state.localEvent.isBackspaceClick === true) {
      model.FinishTimeString = e.target.value;
    } else {
      if (e.target.value !== '') {
        if (
          e.target.value.length === 1 &&
          e.target.value !== '0' &&
          e.target.value !== '1'
        ) {
          finishTime = '0' + e.target.value + ':';
        } else if (e.target.value.length === 2) {
          finishTime = e.target.value + ':';
        } else {
          finishTime = e.target.value;
        }
      }
      model.FinishTimeString = finishTime;
    }

    this.setState({ model: model }, () => {
      this.validateFinishTime();
    });
  }

  handleFollowUpTimeChange(e) {
    if (!e || !e.target) return;
    let model = { ...this.state.newModel };
    var followUpTime = null;

    // For HTML time inputs, accept the value as-is and let the browser manage formatting
    if (e.target.type === 'time') {
      model.FollowUpTimeString = e.target.value;
      // Fix: write back to newModel (the controlled source for FollowUpTimeString)
      this.setState({ newModel: model }, () => this.validateFollowUpTime());
      return;
    }

    // Legacy support for text inputs (if any remain)
    if (this.state.localEvent.isBackspaceClick === true) {
      model.FollowUpTimeString = e.target.value;
    } else {
      if (e.target.value !== '') {
        if (
          e.target.value.length === 1 &&
          e.target.value !== '0' &&
          e.target.value !== '1'
        ) {
          followUpTime = '0' + e.target.value + ':';
        } else if (e.target.value.length === 2) {
          followUpTime = e.target.value + ':';
        } else {
          followUpTime = e.target.value;
        }
      }
      model.FollowUpTimeString = followUpTime;
    }

    // Fix: write back to newModel (not model)
    this.setState({ newModel: model }, () => {
      this.validateFollowUpTime();
    });
  }

  validateFinishTime() {
    let model = { ...this.state.elementModel };
    let finishTime = this.state.model.FinishTimeString;

    // Reset messages and button state
    model.display_message = '';
    model.disableButtons = 'disabled'; // Start with buttons disabled

    // Early exit if no finish time has been entered yet
    if (!finishTime || finishTime === '') {
      this.setState({ elementModel: model });
      return;
    }

    try {
      // For HTML5 time input (type="time"), we get a 24-hour format (HH:MM)
      // Extract hours and minutes
      const timeParts = finishTime.split(':');
      if (timeParts.length !== 2) {
        throw new Error('Invalid time format');
      }

      let finishHours = parseInt(timeParts[0], 10);
      const finishMinutes = parseInt(timeParts[1], 10);

      // Make sure finishTime is valid
      if (
        isNaN(finishHours) ||
        isNaN(finishMinutes) ||
        finishHours < 0 ||
        finishHours > 23 ||
        finishMinutes < 0 ||
        finishMinutes > 59
      ) {
        throw new Error('Invalid time values');
      }

      // Get job start time in 24-hour format for comparison
      const jobDateTime = moment(this.props.model.JobDateTime);
      const jobHours = jobDateTime.hours();
      const jobMinutes = jobDateTime.minutes();

      // Compare finish time to job start time
      const jobTimeValue = jobHours * 60 + jobMinutes;
      const finishTimeValue = finishHours * 60 + finishMinutes;

      // Decision logic for enabling/disabling buttons
      if (finishTimeValue <= jobTimeValue) {
        model.display_message = 'Finish time must be later than start time.';
        model.disableButtons = 'disabled';
      } else {
        // Valid time - ENABLE BUTTONS!
        model.disableButtons = ''; // Empty string means not disabled
      }
    } catch (error) {
      model.display_message = 'Please enter a valid time.';
      model.disableButtons = 'disabled';
    }

    // Update the state
    this.setState({ elementModel: model });
  }

  validateFollowUpTime(e) {
    // Make event optional; don't assume e.target exists
    let model = { ...this.state.elementModel };
    if (e && e.target && typeof e.target.value !== 'undefined') {
      model.ampm = e.target.value;
    }
    this.setState({ elementModel: model }, () => {
      // Keep existing behavior: re-run finish time validation (safe no-op for follow-up path)
      this.validateFinishTime();
    });
  }

  // Enable Yes-flow submit only when both date and time are present and valid
  canSubmitYesFlow() {
    const date = this.state.newModel?.JobDate;
    const time = this.state.newModel?.FollowUpTimeString;
    if (!date || !time) return false;
    const parts = String(time).split(':');
    if (parts.length !== 2) return false;
    const h = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10);
    if (Number.isNaN(h) || Number.isNaN(m)) return false;
    if (h < 0 || h > 23 || m < 0 || m > 59) return false;
    return true;
  }

  handleYesClick() {
    let model = { ...this.state.model };
    const savedFinishTime = model.FinishTimeString || '';

    if (sessionStorage.getItem('isImpersonation') === 'true') {
      model.FinishTimeString = null;
      this.setState({ model, savedFinishTime });
      this.setState({ localEvent: { ...this.state.localEvent, isYesClick: true } });
      return;
    }

    FetchData('/EndTimeYesButtonClick', 'POST', this.user.token, model).then(
      (data) => {
        if (data === 'Success') {
          model.FinishTimeString = null;
          this.setState({ model: model, savedFinishTime }, () => {});

          let model2 = { ...this.state.localEvent };
          model2.isYesClick = true;
          this.setState({ localEvent: model2 }, () => {});
        } else {
          this.setState(
            {
              alert: {
                color: 'warning',
                message: data,
                isOpen: true,
              },
            },
            () => {
              window.setTimeout(() => {
                this.setState({ alert: { isOpen: false } });
              }, Timeout(alert.message));
            }
          );
        }
      }
    );
  }

  handleNoClick() {
    if (this.txtEndTime.value === null || this.txtEndTime.value === '') {
      this.setState({
        alert: {
          color: 'warning',
          message: 'Please enter Finish Time.',
          isOpen: true,
        },
      });
    } else {
      if (IsImpersonation()) {
        this.props.handleSaveEventSuccess({ message: '', modal: false, color: 'success' });
        return;
      }

      let model = { ...this.state.model };

      FetchData('/EndTimeNoButtonClick', 'POST', this.user.token, model).then(
        (data) => {
          if (data === 'Success') {
            // The follow-up question only shows for jobs within the last 24 hours (see the
            // JobDateTime check above), so an older job can only be submitted through this
            // path -- let the interpreter know a follow-up still needs a scheduler's help.
            const isJobOlderThan24Hours = moment(
              this.props.model.JobDateTime,
            ).isBefore(moment().subtract(24, 'hours'));

            if (isJobOlderThan24Hours) {
              const message =
                'Finish Time has been updated. This job is more than 24 hours old, so a follow-up appointment cannot be created here — please call the schedulers at 800-522-2320 if one is needed.';

              // Show the warning in this modal first, before it closes, so the interpreter
              // actually sees it rather than it only appearing after the modal is gone. Held
              // 5s longer than the usual alert duration since this one needs to actually be read,
              // and suppressed on the parent job list once this modal closes -- it was already seen here.
              this.setState(
                {
                  alert: {
                    color: 'warning',
                    message,
                    isOpen: true,
                  },
                },
                () => {
                  window.setTimeout(() => {
                    this.props.handleSaveEventSuccess({
                      message,
                      modal: false,
                      color: 'warning',
                      finishTimeString: model.FinishTimeString,
                      skipParentAlert: true,
                    });
                  }, Timeout(message) + 5000);
                },
              );
            } else {
              this.props.handleSaveEventSuccess({
                message: 'Finish Time has been updated.',
                modal: false,
                color: 'success',
                finishTimeString: model.FinishTimeString,
              });
            }
          } else {
            this.setState(
              {
                alert: {
                  color: 'warning',
                  message: data,
                  isOpen: true,
                },
              },
              () => {
                window.setTimeout(() => {
                  this.setState({ alert: { isOpen: false } });
                }, Timeout(alert.message));
              }
            );
          }

          //this.setState({
          //    display_message: data.displayMessage
          //});
        }
      );
    }
  }

  handleSubmitClick() {
    // Each submit creates a follow-up job server-side, and the request blocks on two
    // synchronous email sends -- without this guard a second click during that window
    // creates a second job.
    if (this.state.isSubmitting) {
      return;
    }

    if (
      this.state.localEvent.isYesClick &&
      (this.state.newModel.JobDate === null ||
        this.state.newModel.JobDate === '')
    ) {
      this.setState({
        alert: {
          color: 'warning',
          message: 'Please choose Date.',
          isOpen: true,
        },
      });
    } else if (
      this.state.localEvent.isYesClick &&
      (this.state.newModel.FollowUpTimeString === null ||
        this.state.newModel.FollowUpTimeString === '')
    ) {
      this.setState({
        alert: {
          color: 'warning',
          message: 'Please enter Finish Time.',
          isOpen: true,
        },
      });
    } else {
      if (IsImpersonation()) {
        this.props.handleSaveEventSuccess({ message: '', modal: false, color: 'success', showTimeout: false });
        return;
      }

      let model = { ...this.state.model };
      const jobDate = this.state.newModel.JobDate; // 'YYYY-MM-DD'
      const followUpTime = this.state.newModel.FollowUpTimeString; // 'HH:mm'
      const dt = moment(`${jobDate} ${followUpTime}`, 'YYYY-MM-DD HH:mm');
      model.JobDateTime = dt.isValid()
        ? dt.format('YYYY-MM-DDTHH:mm:ss')
        : null;

      this.setState({ isSubmitting: true });

      FetchData(
        '/EndTimeFollowUpSubmit/?unAvailable=' +
          this.state.newModel.UnAvailable,
        'POST',
        this.user.token,
        model
      ).then((data) => {
        this.setState({ isSubmitting: false });
        if (data === 'Success') {
          this.props.handleSaveEventSuccess({
            message: 'End time follow up has been submitted.',
            modal: false,
            color: 'success',
            showTimeout: false,
            finishTimeString: this.state.savedFinishTime,
          });
        } else {
          this.setState(
            {
              alert: {
                color: 'warning',
                message: data,
                isOpen: true,
              },
            },
            () => {
              window.setTimeout(() => {
                this.setState({ alert: { isOpen: false } });
              }, Timeout(alert.message));
            }
          );
        }
      }).catch(() => {
        this.setState({
          isSubmitting: false,
          alert: {
            color: 'warning',
            message: 'Could not reach the server. Please try again.',
            isOpen: true,
          },
        });
      });
    }
  }

  handleSaveEventSuccessComment(alert) {
    const modalEndTimeComment =
      typeof alert.modalEndTimeComment === 'boolean'
        ? alert.modalEndTimeComment
        : alert.modal;

    this.setState(
      {
        modalEndTimeComment: modalEndTimeComment,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
        //if (alert.modal === false)
        //    this.setModalEndTimeComment();
      }
    );
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;
    const isMobile = window.innerWidth < 768;

    return (
      <div>
        <Draggable
          handle=".workorder-int-form-endtime-handle"
          onDrag={this.handleDrag}
          disabled={isMobile}
          {...dragHandlers}
        >
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              width: 'min(800px, 95vw)',
              transform: isMobile ? undefined : `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
            }}
          >
            <ModalHeader className="workorder-int-form-endtime-handle handle">
              Interpreter Check In #{this.props.model.JobNum}
            </ModalHeader>
            <ModalBody>
            <div>
              <Row>
                <Col style={{ textAlign: 'center' }}>
                  <Alert
                    color={this.state.alert.color}
                    isOpen={this.state.alert.isOpen}
                  >
                    {this.state.alert.message}
                  </Alert>
                </Col>
              </Row>
              <Row>
                <Col>
                  <center>
                    <img src={Logo} alt="Logo" />
                  </center>
                </Col>
              </Row>
              {!this.state.localEvent.isYesClick && (
                <Fragment>
                  <Row>
                    <Col>
                      <center>
                        <br />
                        <p>
                          Claimant:{' '}
                          <b>
                            {this.props.model.ClmLastName +
                              ', ' +
                              this.props.model.ClmFirstName}
                          </b>{' '}
                          <br />
                          On:{' '}
                          <b>
                            {moment(this.props.model.JobDateTime).format(
                              'dddd'
                            ) +
                              ' ' +
                              moment(this.props.model.JobDateTime).format(
                                'MM/DD/YYYY'
                              )}
                          </b>{' '}
                          <br />
                          at:{' '}
                          <b>
                            {moment(this.props.model.JobDateTime).format(
                              'hh:mm A'
                            )}
                          </b>
                        </p>
                      </center>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <center>
                        <p style={{ color: 'red', fontWeight: 'bold' }}>
                          If you did NOT interpret for any reason, please Call
                          800-522-2320
                        </p>
                      </center>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <center>
                        <p>Finish Time:</p>
                        <p>
                          <input
                            name="FinishTimeString"
                            value={this.state.model.FinishTimeString ?? ''}
                            type="time" // Changed from "text" to "time"
                            ref={(input) => {
                              this.txtEndTime = input;
                            }}
                            onKeyDown={this.handlekeyDown}
                            onChange={this.handleChange}
                            style={{
                              width: '120px', // Increased width to accommodate time control
                              color:
                                this.state.elementModel.disableButtons ===
                                'disabled'
                                  ? 'red'
                                  : 'black',
                              borderColor:
                                this.state.elementModel.disableButtons ===
                                'disabled'
                                  ? 'red'
                                  : 'black',
                            }}
                          />{' '}
                          {this.state.elementModel.display_message !== '' && (
                            <p style={{ color: 'red' }}>
                              {this.state.elementModel.display_message}
                            </p>
                          )}
                        </p>
                      </center>
                    </Col>
                  </Row>
                  {/* Only show follow-up question if job was at least 24 hours ago */}
                  {moment(this.props.model.JobDateTime).isAfter(
                    moment().subtract(24, 'hours')
                  ) && (
                    <>
                      <Row>
                        <Col>
                          <center>
                            <p>Are there any follow up appointments?</p>
                          </center>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col>
                          <center>
                            <Button
                              color={
                                this.state.elementModel.disableButtons ===
                                'disabled'
                                  ? 'secondary'
                                  : 'success'
                              }
                              size="medium"
                              className="btn-portal-action"
                              disabled={IsImpersonation() ? false : this.state.elementModel.disableButtons === 'disabled'}
                              onClick={this.handleYesClick}
                              style={{
                                margin: '0 10px', // Add horizontal margin for spacing
                                minWidth: '100px', // Set minimum width
                                padding: '5px 10px', // Add more padding
                                fontSize: '1.1rem', // Slightly larger font
                              }}
                            >
                              <img
                                src={SaveIcon}
                                style={{
                                  width: '16px',
                                  height: '16px',
                                  cursor: 'pointer',
                                }}
                                alt="Yes"
                              />{' '}
                              Yes
                            </Button>{' '}
                            <Button
                              color={
                                this.state.elementModel.disableButtons ===
                                'disabled'
                                  ? 'secondary'
                                  : 'danger'
                              }
                              size="medium"
                              className="btn-portal-action"
                              disabled={IsImpersonation() ? false : this.state.elementModel.disableButtons === 'disabled'}
                              onClick={this.handleNoClick}
                              style={{
                                margin: '0 10px', // Add horizontal margin for spacing
                                minWidth: '100px', // Set minimum width
                                padding: '5px 10px', // Add more padding
                                fontSize: '1.1rem', // Slightly larger font
                              }}
                            >
                              <img
                                src={RemoveIcon}
                                style={{
                                  width: '16px',
                                  height: '16px',
                                  cursor: 'pointer',
                                }}
                                alt="No"
                              />{' '}
                              No
                            </Button>
                          </center>
                        </Col>
                      </Row>
                    </>
                  )}{' '}
                </Fragment>
              )}
              {this.state.localEvent.isYesClick && (
                <Fragment>
                  <Row>
                    <Col>
                      <p></p>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <center>
                        <input
                          name="UnAvailable"
                          type="checkbox"
                          checked={!!this.state.newModel.UnAvailable}
                          onChange={this.handleNewModelChange}
                        />
                      </center>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <center>
                        <p style={{ fontWeight: 'bold' }}>
                          Check the box above if you are NOT available for this
                          followup appointment.
                        </p>
                      </center>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <center>
                        <p>Date:</p>
                        <p>
                          <input
                            name="JobDate"
                            type="date"
                            className="form-control"
                            value={
                              this.state.newModel.JobDate
                                ? moment(this.state.newModel.JobDate).format('YYYY-MM-DD')
                                : ''
                            }
                            style={{ width: '150px' }}
                            onChange={this.handleNewModelChange}
                          ></input>
                        </p>
                      </center>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <center>
                        <p>New Job Time:</p>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <input
                            name="FollowUpTimeString"
                            value={this.state.newModel.FollowUpTimeString}
                            type="time"
                            ref={(input) => {
                              this.txtFollowUpTime = input;
                            }}
                            onKeyDown={this.handlekeyDown}
                            onChange={this.handleFollowUpTimeChange}
                          />
                          {this.state.elementModel.display_message !== '' && (
                            <span style={{ color: 'red', marginLeft: '8px' }}>
                              {this.state.elementModel.display_message}
                            </span>
                          )}
                        </div>
                      </center>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <center>
                        <p>
                          Please add Date and Time to your Calendar if you are
                          available
                        </p>
                      </center>
                    </Col>
                  </Row>
                </Fragment>
              )}
            </div>
          </ModalBody>
          <ModalFooter style={{ justifyContent: 'center' }}>
            {!this.state.localEvent.isYesClick &&
              moment(this.props.model.JobDateTime).isBefore(
                moment().subtract(24, 'hours')
              ) && (
                <Button
                  className="btn-portal-action"
                  disabled={IsImpersonation() ? false : this.state.elementModel.disableButtons === 'disabled'}
                  color={'success'}
                  size="sm"
                  onClick={this.handleNoClick}
                >
                  <img
                    src={SaveIcon}
                    style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                    alt="Submit"
                  />{' '}
                  Submit
                </Button>
              )}
            {this.state.localEvent.isYesClick && (
              <Button
                className="btn-portal-action"
                disabled={
                  IsImpersonation()
                    ? false
                    : !this.canSubmitYesFlow() || this.state.isSubmitting
                }
                color={'success'}
                size="sm"
                onClick={this.handleSubmitClick}
              >
                <img
                  src={SaveIcon}
                  style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                  alt="Submit"
                />{' '}
                {this.state.isSubmitting ? 'Submitting...' : 'Submit'}
              </Button>
            )}
          </ModalFooter>
          </Modal>
        </Draggable>

        {this.state.modalEndTimeComment && (
          <WorkOrderIntFormEndTimeComment
            jobmodel={this.state.model}
            modal={this.state.modalEndTimeComment}
            alert={this.state.alert}
            setModal={this.setModalEndTimeComment}
            handleSaveEventSuccess={this.handleSaveEventSuccessComment}
          />
        )}
      </div>
    );
  }
}
